<template lang="pug" functional>
  div
    v-card.rations-skeleton(v-for="i in props.count" :key="i")
      .rations-table__row.rations-table__row--body
        .rations-table__column
          .text-skeleton
        .rations-table__column
          .text-skeleton
        .rations-table__column
          .text-skeleton

</template>

<script>
export default {
  name: 'RationTableRowSkeleton',

  props: {
    count: {
      type: Number,
      default: 1
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/sass/abstracts/_mixins.scss';
  @import '@/sass/abstracts/_variables.scss';

  .rations-skeleton {
    &:not(:last-child) {
      margin-bottom: 1rem;
    }
  }

  .text-skeleton {
    height: 2rem;
    width: 60%;
    border-radius: .8rem;

    @include skeleton;
  }
</style>
